var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invest"},[_c('div',{staticClass:"invest-title"},[_c('van-icon',{staticClass:"invest-arrow-left",attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.goableBack()}}}),_c('span',[_vm._v("投资以下产品可获积分奖励")])],1),_c('tian-products-regular')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }